import { Component, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RangeDatepickerComponent } from '../../range-datepicker/range-datepicker.component';
import { AgGridService } from '../../ag-grid/ag-grid.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CommonFilterService } from 'src/app/shared/services/common-filter.service';
import { DatePipe } from '@angular/common';
import { DateRangeType } from 'src/app/shared/enum/common-enum';
import { CustomSelect2Component } from '../../custom-select2/custom-select2.component';
import { StorageName } from '../../../enum/common-enum';
import { LoadDropdownDataService } from '../../load-dropdown-data/load-dropdown-data.service';
import { catchError } from 'rxjs';
import { ResponseModel } from '../../../models/response-model.model';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-advanced-filter-popup',
  templateUrl: './advanced-filter-popup.component.html',
  styleUrls: ['./advanced-filter-popup.component.scss'],
  providers :[DatePipe]
})
export class AdvancedFilterPopupComponent extends CommonService {
  @Input() data : any = {};
  storageName = StorageName;
  @ViewChildren(RangeDatepickerComponent) dateRangeDatepicker: QueryList<RangeDatepickerComponent>
  @ViewChild("branchDropdown") branchDropdown : CustomSelect2Component;
  selectedAccountLedgerIds      = [];
  filterProductDropdown:any
  advanceFilterRequest :any = {}
  selectedMetalIds =[];
  selectedProductIds = [];
  @Output() fillDropdownData = new EventEmitter();
  constructor
    (
      public activeModal: NgbActiveModal,
      public renderer: Renderer2,
      public agGridService: AgGridService,
      public storageService: StorageService,
      public commonFilterService: CommonFilterService,
      public loadDropdownDataService: LoadDropdownDataService,
    ) {super(renderer); 
  }

  ngAfterViewInit(): void {
    this.setAlreadyAppliedData();
  }

  setAlreadyAppliedData() {
    var previousAppliedFilters = this.storageService.retrieve(this.data.filterStorageName);
    if (previousAppliedFilters != undefined) {

      //Metals
      this.selectedMetalIds = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "metalId", this.data.getAllDropdownModel.metalDropdown, "multiselectDropdown");
      this.advanceFilterRequest.selectedMetals = this.selectedMetalIds?.map((x) => x.id);
      this.advanceFilterRequest.branchId = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "branchId", undefined, "dropdown");
      this.branchDropdown?.setDataSource(this.data.getAllDropdownModel?.branchDropdown ,String(this.advanceFilterRequest.branchId));
      if(this.advanceFilterRequest.selectedMetals && this.advanceFilterRequest.branchId){
        this.filterProductMetalAndBranchWise(this.advanceFilterRequest.selectedMetals ,this.advanceFilterRequest.branchId)
      }
      //Products
      this.selectedProductIds = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "productId", this.data.getAllDropdownModel.productDropdown, "multiselectDropdown");
      this.advanceFilterRequest.selectedProducts = this.selectedProductIds?.map((x) => x.id);
      //Title
      this.advanceFilterRequest.title = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "title", undefined, "input");
      
      //Design
      this.advanceFilterRequest.design = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "designNo", undefined, "input");
      //Barcode
      this.advanceFilterRequest.barcode = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "barcodeNo", undefined, "input");

      this.advanceFilterRequest.jcno = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "catelogueNo", undefined, "input");

      this.advanceFilterRequest.bfm = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "billOfMaterialNo", undefined, "input");

      this.advanceFilterRequest.sku = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "sku", undefined, "input");

      this.advanceFilterRequest.fromDate = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "fromDate", undefined, "input");

      this.advanceFilterRequest.toDate = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "toDate", undefined, "input");

    }
  }

  onClickAdvancedFilter() {
    this.storageService.removeItem(this.data.filterStorageName);
 
    this.commonFilterService.performFilterColumnwise('metalId', this.advanceFilterRequest.selectedMetals, undefined, this.data.filterStorageName, '');

    this.commonFilterService.performFilterColumnwise('productId', this.advanceFilterRequest.selectedProducts, undefined, this.data.filterStorageName, '');
    
    if (this.advanceFilterRequest.branchId != undefined)
      this.commonFilterService.performFilterColumnwise('branchId', undefined, this.advanceFilterRequest?.branchId, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest.title != undefined)
      this.commonFilterService.performFilterColumnwise('title', undefined, this.advanceFilterRequest?.title, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest.design != undefined)
      this.commonFilterService.performFilterColumnwise('designNo', undefined, this.advanceFilterRequest?.design, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest.barcode != undefined)
      this.commonFilterService.performFilterColumnwise('barcodeNo', undefined, this.advanceFilterRequest?.barcode, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest.jcno != undefined)
      this.commonFilterService.performFilterColumnwise('catelogueNo', undefined, this.advanceFilterRequest?.jcno, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest.bfm != undefined)
      this.commonFilterService.performFilterColumnwise('billOfMaterialNo', undefined, this.advanceFilterRequest?.bfm, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest.sku != undefined)
      this.commonFilterService.performFilterColumnwise('sku', undefined, this.advanceFilterRequest?.sku, this.data.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest?.fromDate != undefined)
      this.commonFilterService.performFilterColumnwise('fromDate', undefined, this.advanceFilterRequest?.fromDate, this.data.filterStorageName, 'dateFilter');

    if (this.advanceFilterRequest?.toDate != undefined)
      this.commonFilterService.performFilterColumnwise('toDate', undefined, this.advanceFilterRequest?.toDate, this.data.filterStorageName, 'dateFilter');

    var filterData = this.commonFilterService.processFilterData(this.data.filterStorageName)

    this.advanceFilterRequest.filters = filterData;
    this.activeModal.close(this.advanceFilterRequest)
  }

  filterProductMetalAndBranchWise(metalIds: any[], branchId: any) {
    const selectedMetalIds = Array.isArray(metalIds) ? metalIds : [metalIds];
    const branchIdS = branchId?.toString() || '';
    this.filterProductDropdown = this.data?.getAllDropdownModel?.productDropdown?.filter(item => selectedMetalIds.includes(item?.extra1) && item?.extra4 === branchIdS);
    const selectedProductExist = this.filterProductDropdown?.some(item => this.advanceFilterRequest?.selectedProducts?.includes(item?.id));
    if (this.filterProductDropdown?.length === 0 || !selectedProductExist) {
      this.selectedProductIds = [];
    }
  }
  clearFields() {
    this.advanceFilterRequest = {}
    this.selectedMetalIds = [];
    this.selectedProductIds = [];
    this.commonFilterService.setDefaultFilter(this.data.apiRequestStorageName, this.data.apiRequestModel, this.data.filterStorageName, { setDefaultDateRangePickerData: { dateRangeType: DateRangeType.Today } });
    this.setAlreadyAppliedData();
  }
   getAllDropdownDataFormWise(branchId) {
      this.loadDropdownDataService.getAllDropdownDataFormWise(this.data?.formName, branchId)
        .pipe(catchError((err) => this.handleError((err))))
        .subscribe((res: ResponseModel) => {
          if (res.isSuccess)
            this.fillDropdownData.emit(res?.response);
          this.data.getAllDropdownModel.productDropdown = res?.response?.productDropdown;
          this.filterProductMetalAndBranchWise(this.advanceFilterRequest?.selectedMetals, this.advanceFilterRequest?.branchId)
        })
    }
}